import React, {useMemo, useState} from 'react';
import {HiOutlinePhotograph} from 'react-icons/hi';
import {FiChevronLeft, FiChevronRight} from 'react-icons/fi';
import {parsePostImages, uploadUrl} from '../utils/postImages';
import '../styles/compsStyles/image.css';

const Image = props => {
  const [fullVideo, setFullVideo] = useState(false);
  const [index, setIndex] = useState(0);
  const [touchX, setTouchX] = useState(null);

  const urls = useMemo(() => {
    const names = parsePostImages(props.image);
    if (names.length) return names.map(uploadUrl);
    if (props.data) return [props.data];
    return [];
  }, [props.image, props.data]);

  const total = urls.length;
  const current = urls[Math.min(index, Math.max(total - 1, 0))] || '';

  const go = (next) => {
    if (total < 2) return;
    setIndex((next + total) % total);
  };

  return (
    <div className={!fullVideo ? 'ImagePlayer smallscreen' : 'ImagePlayer fullscreen'}>
      {current ? <img src={current} alt={props.title || 'imag'} /> : null}

      {total > 1 && (
        <>
          <button className="imageCarouselNav isPrev" type="button" aria-label="Previous photo" onClick={() => go(index - 1)}>
            <FiChevronLeft />
          </button>
          <button className="imageCarouselNav isNext" type="button" aria-label="Next photo" onClick={() => go(index + 1)}>
            <FiChevronRight />
          </button>
          <div className="imageCarouselDots">
            {urls.map((_, i) => (
              <button
                key={`${urls[i]}-${i}`}
                type="button"
                className={i === index ? 'isActive' : ''}
                aria-label={`Photo ${i + 1}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </>
      )}

      <div
        className="videoControls"
        onTouchStart={event => setTouchX(event.changedTouches[0].clientX)}
        onTouchEnd={event => {
          if (touchX == null) return;
          const dx = event.changedTouches[0].clientX - touchX;
          if (dx > 40) go(index - 1);
          if (dx < -40) go(index + 1);
          setTouchX(null);
        }}
      >
        <div className="videoPlayerHeader">
          <p><i><HiOutlinePhotograph /></i> {props.title}</p>
          <p><span>{props.share}</span><span>{props.report}</span></p>
        </div>
        <div className="buttomsVideo" onClick={() => setFullVideo(prev => !prev)} />
        <div className="underLineVideo" />
      </div>
    </div>
  );
};

export default Image;
